module.exports = __webpack_public_path__ + "img/home_c2.e50ed188.png";